import React from "react";

function LoginToDownloadModalSvg() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="179"
      height="130"
      fill="none"
      viewBox="0 0 179 130"
    >
      <mask
        id="mask0_1053_29974"
        style={{ maskType: "alpha" }}
        width="179"
        height="130"
        x="0"
        y="0"
        maskUnits="userSpaceOnUse"
      >
        <path fill="#D9D9D9" d="M0 0H179V130H0z"></path>
      </mask>
      <g mask="url(#mask0_1053_29974)">
        <path
          fill="#131313"
          d="M193.218 128.757H-5.111v1.507h198.329v-1.507z"
        ></path>
        <path
          fill="#F8A3A2"
          d="M108.925 101.879s3.223 19.542 9.469 27.318l-61.463.668s8.48-17.097 8.77-26.978l43.224-1.008z"
        ></path>
        <path
          fill="#101C3A"
          d="M121.098 121.93s-15.675 5.46-33.505 5.649c-17.82-.189-33.506-5.649-33.506-5.649-26.431 27.008 24.266 36.021 33.506 36.021 8.76 0 59.427-9.062 33.505-36.021zM101.632 9.984c7.793 9.612 13.74 8.574 8.94 19.263-4.799 10.69 12.941 5.13 11.964 15.95-.978 10.81-9.35 10.03-1.677 19.023s-8.531 25.422-8.531 25.422H64.146s-17.332-8.175-12.532-21.828c4.789-13.654-3.543-13.784 8.002-23.306 7.383-6.088.598-9.771.598-18.674 0-9.831 9.759-14.432 14.249-13.484 4.49.938 14.178-18.375 27.169-2.366z"
        ></path>
        <path
          fill="#1C64F2"
          d="M59.376 54.589c-8.631 4.76-25.024 18.095-33.615 27.767-8.591 9.671-.828 23.804 11.344 18.853 12.173-4.95 34.883-20.29 38.315-24.163 6.735-7.606-2.774-29.783-16.044-22.457zM115.282 54.01c8.63 4.76 27.459 18.674 36.039 28.345 8.591 9.672.829 23.805-11.344 18.854-12.173-4.95-34.883-20.291-38.315-24.164-6.725-7.605.349-30.361 13.62-23.035z"
        ></path>
        <path
          fill="#1C64F2"
          d="M117.915 89.052c1.227-3.603.708-13.843.02-18.734-.559-5.669.06-14.362-5.598-17.357-2.544-1.347-13.63-1.986-18.598-3.393H81.107c-3.912.998-13.52 3.373-16.893 3.443-2.724.06-4.41 2.196-5.797 6.338-1.516 7.875-1.955 15.37-3.253 23.276-.738 4.231-.06 7.585 2.515 13.753 3.732 10.49-5.338 26.979-5.338 26.979s37.776 14.991 70.164-.3c.01-.01-9.459-19.692-4.59-34.005z"
        ></path>
        <path
          fill="#fff"
          d="M54.945 118.456l-.489-.21c2.165-5.17 5.438-14.871 2.983-21.788-2.644-6.328-3.262-9.702-2.524-13.884.569-3.463.978-6.906 1.377-10.24.39-3.304.798-6.707 1.357-10.12l.529.09c-.559 3.393-.958 6.796-1.357 10.09-.4 3.334-.808 6.787-1.377 10.26-.709 4.072-.11 7.376 2.494 13.604 2.395 6.757-.309 15.8-2.993 22.198zM118.256 111.939c-1.697-6.288-3.173-15.38-.589-22.976 1.147-3.364.758-12.915.06-18.235l.529-.07c.708 5.37 1.087 15.041-.08 18.475-2.544 7.465-1.078 16.438.599 22.666l-.519.14z"
        ></path>
        <path
          fill="#F8A3A2"
          d="M93.79 38.74v10.998c5.247 13.584-6.476 30.542-6.476 30.542s-10.986-18.315-6.007-30.581v-15.82c0 .01 4.73 2.306 12.482 4.86z"
        ></path>
        <path
          fill="#101C3A"
          d="M91.495 44.997c.808-.789 1.626-3.873 2.504-4.172V38.19c-8.022-2.555-12.901-4.85-12.901-4.85v8.962c.608.479 1.636 3.174 2.893 4.092 2.126 1.567 4.93 1.118 7.504-1.397z"
        ></path>
        <path
          fill="#F8A3A2"
          d="M96.672 28.379c-.42-3.224-.589-5.45-5.767-7.206-5.538-1.877-10.427.519-12.303 6.058-.648 1.916.549 10.51 1.277 13.195.51 1.846 6.256 5.08 6.256 5.08.31.47 2.634.46 2.954-.03 0 0 5.587-3.763 6.046-5.01.958-2.625 1.657-11.139 1.537-12.087z"
        ></path>
        <path
          fill="#101C3A"
          d="M86.884 37.043l-.24-.48c.01-.01 1.437-.738 1.138-1.406-.908-2.027-.539-4.761-.529-4.871l.529.07c0 .03-.37 2.705.479 4.581.529 1.148-1.297 2.066-1.377 2.106zM80.608 29.547l-.299-.44c2.674-1.796 4.66-.15 4.68-.14l-.35.41c-.06-.06-1.706-1.397-4.03.17zM93.779 29.677c-.06-.07-1.487-1.627-4.011-.43l-.23-.478c2.914-1.387 4.63.539 4.65.559l-.41.35zM86.496 39.736c-1.477 0-2.425-.31-2.465-.33l.17-.508c.01 0 .918.299 2.295.299 1.387 0 4.03-.828 4.06-.838l.16.509c-.11.04-2.753.868-4.22.868zM82.924 20.155s8.9 7.206 15.147 8.853c0-.01 1.526-13.963-15.147-8.853z"
        ></path>
        <path
          fill="#F0E3DD"
          d="M99.856 96.12c0 5.778-2.554 10.469-12.562 10.469s-12.562-4.691-12.562-10.47c0-5.779-9.46-10.47 12.562-10.47 22.021 0 12.562 4.691 12.562 10.47z"
        ></path>
        <path
          fill="#101C3A"
          d="M83.621 122.428c-1.476 0-2.833-.199-3.98-.678l.209-.49c6.835 2.865 22.31-4.9 22.46-4.98l.239.479c-.539.27-11.295 5.669-18.928 5.669z"
        ></path>
        <path
          fill="#F8A3A2"
          d="M86.176 126.382c-.419-.789 2.095-2.785 2.025-7.326-.07-4.531 1.856-2.984 4.89-5.569 3.033-2.585 3.342-3.643 7.393-2.186 4.051 1.457 5.139 1.128 6.795-.22 1.646-1.347 16.523-14.442 22.729-21.22 6.207-6.776 24.805 3.574 12.553 14.184l-39.732 17.596s-3.562 1.038-5.588-1.437c-2.025-2.476-4.66.399-4.71 2.046-.049 1.647 1.388 3.144-.059 3.703-1.457.569-2.415-1.607-2.415-1.607s-3.183 3.353-3.88 2.036z"
        ></path>
        <path
          fill="#425FEC"
          d="M151.59 99.512c-8.152 7.316-15.037 10.73-30.462 18.525 0 0-7.094-8.065-8.421-14.103 0 0 17.171-17.647 23.527-22.677 6.356-5.02 21.602 12.656 15.356 18.255z"
        ></path>
        <path
          fill="#F8A3A2"
          d="M90.915 126.382c.42-.789-2.095-2.785-2.025-7.326.07-4.531-1.856-2.984-4.89-5.569-3.033-2.585-3.342-3.643-7.393-2.186-4.05 1.457-5.138 1.128-6.795-.22-1.646-1.347-16.523-14.442-22.73-21.22-6.205-6.776-24.804 3.574-12.551 14.184l39.731 17.596s3.562 1.038 5.588-1.437c2.025-2.476 4.66.399 4.71 2.046.05 1.647-1.388 3.144.06 3.703 1.456.569 2.414-1.607 2.414-1.607s3.183 3.353 3.881 2.036z"
        ></path>
        <path
          fill="#1C64F2"
          d="M25.461 99.573c8.152 7.316 15.077 10.669 30.502 18.464 0 0 7.095-8.064 8.422-14.103 0 0-17.172-17.646-23.528-22.676-6.356-5.02-21.642 12.715-15.396 18.315z"
        ></path>
        <path fill="#99CEFF" d="M101.742 126.831h-.119v.769h.119v-.769z"></path>
        <path fill="#9BCEFF" d="M101.862 126.831h-.119v.769h.119v-.769z"></path>
        <path fill="#9CCFFF" d="M101.982 126.831h-.12v.769h.12v-.769z"></path>
        <path fill="#9DCFFF" d="M102.102 126.831h-.12v.769h.12v-.769z"></path>
        <path fill="#9ED0FF" d="M102.212 126.831h-.12v.769h.12v-.769z"></path>
        <path fill="#9FD1FF" d="M102.331 126.831h-.12v.769h.12v-.769z"></path>
        <path fill="#A1D1FF" d="M102.451 126.831h-.12v.769h.12v-.769z"></path>
        <path fill="#A2D2FF" d="M102.57 126.831h-.119v.769h.119v-.769z"></path>
        <path fill="#A4D2FF" d="M102.69 126.831h-.12v.769h.12v-.769z"></path>
        <path fill="#A5D3FF" d="M102.8 126.831h-.12v.769h.12v-.769z"></path>
        <path fill="#A6D3FF" d="M102.92 126.831h-.12v.769h.12v-.769z"></path>
        <path fill="#A7D4FF" d="M103.039 126.831h-.12v.769h.12v-.769z"></path>
        <path fill="#A9D4FF" d="M103.159 126.831h-.119v.769h.119v-.769z"></path>
        <path fill="#AAD5FF" d="M103.279 126.831h-.12v.769h.12v-.769z"></path>
        <path fill="#ABD5FF" d="M103.389 126.831h-.12v.769h.12v-.769z"></path>
        <path fill="#ACD6FF" d="M103.509 126.831h-.12v.769h.12v-.769z"></path>
        <path fill="#ADD7FF" d="M103.628 126.831h-.12v.769h.12v-.769z"></path>
        <path fill="#AFD7FF" d="M103.748 126.831h-.12v.769h.12v-.769z"></path>
        <path fill="#B0D8FF" d="M103.858 126.831h-.12v.769h.12v-.769z"></path>
        <path fill="#B1D8FF" d="M103.977 126.831h-.12v.769h.12v-.769z"></path>
        <path fill="#B2D9FF" d="M104.097 126.831h-.119v.769h.119v-.769z"></path>
        <path fill="#B4D9FF" d="M104.217 126.831h-.12v.769h.12v-.769z"></path>
        <path fill="#B5DAFF" d="M104.337 126.831h-.12v.769h.12v-.769z"></path>
        <path fill="#B6DBFF" d="M104.446 126.831h-.119v.769h.119v-.769z"></path>
        <path fill="#B7DBFF" d="M104.566 126.831h-.12v.769h.12v-.769z"></path>
        <path fill="#B8DCFF" d="M104.686 126.831h-.12v.769h.12v-.769z"></path>
        <path fill="#BADCFF" d="M104.806 126.831h-.12v.769h.12v-.769z"></path>
        <path fill="#BDF" d="M104.925 126.831h-.12v.769h.12v-.769z"></path>
        <path fill="#BCDDFF" d="M105.035 126.831h-.119v.769h.119v-.769z"></path>
        <path fill="#BDDEFF" d="M105.155 126.831h-.12v.769h.12v-.769z"></path>
        <path fill="#BEDFFF" d="M105.275 126.831h-.12v.769h.12v-.769z"></path>
        <path fill="#C0DFFF" d="M105.394 126.831h-.12v.769h.12v-.769z"></path>
        <path fill="#C1E0FF" d="M105.504 126.831h-.119v.769h.119v-.769z"></path>
        <path fill="#C2E0FF" d="M105.624 126.831h-.12v.769h.12v-.769z"></path>
        <path fill="#C3E1FF" d="M105.744 126.831h-.12v.769h.12v-.769z"></path>
        <path fill="#C5E1FF" d="M105.863 126.831h-.12v.769h.12v-.769z"></path>
        <path fill="#C6E2FF" d="M105.983 126.831h-.12v.769h.12v-.769z"></path>
        <path fill="#C7E3FF" d="M106.093 126.831h-.12v.769h.12v-.769z"></path>
        <path fill="#C8E3FF" d="M106.212 126.831h-.12v.769h.12v-.769z"></path>
        <path fill="#C9E4FF" d="M106.332 126.831h-.12v.769h.12v-.769z"></path>
        <path fill="#CBE4FF" d="M106.452 126.831h-.12v.769h.12v-.769z"></path>
        <path fill="#CDE5FF" d="M106.571 126.831h-.119v.769h.119v-.769z"></path>
        <path fill="#CEE5FF" d="M106.681 126.831h-.119v.769h.119v-.769z"></path>
        <path fill="#CFE6FF" d="M106.801 126.831h-.12v.769h.12v-.769z"></path>
        <path fill="#D0E7FF" d="M106.921 126.831h-.12v.769h.12v-.769z"></path>
        <path fill="#D2E7FF" d="M107.041 126.831h-.12v.769h.12v-.769z"></path>
        <path fill="#D3E8FF" d="M107.15 126.831h-.12v.769h.12v-.769z"></path>
        <path fill="#D4E8FF" d="M107.27 126.831h-.12v.769h.12v-.769z"></path>
        <path
          fill="#D5E9FF"
          d="M107.39 126.831h-.12v.769h.12v-.769zM107.41 126.831h-.02v.769h.02v-.769z"
        ></path>
        <path fill="#99CEFF" d="M94.998 126.831h-.12v.769h.12v-.769z"></path>
        <path fill="#9BCEFF" d="M95.108 126.831h-.12v.769h.12v-.769z"></path>
        <path fill="#9CCFFF" d="M95.227 126.831h-.12v.769h.12v-.769z"></path>
        <path fill="#9DCFFF" d="M95.347 126.831h-.12v.769h.12v-.769z"></path>
        <path fill="#9ED0FF" d="M95.466 126.831h-.12v.769h.12v-.769z"></path>
        <path fill="#9FD1FF" d="M95.576 126.831h-.12v.769h.12v-.769z"></path>
        <path fill="#A1D1FF" d="M95.696 126.831h-.12v.769h.12v-.769z"></path>
        <path fill="#A2D2FF" d="M95.816 126.831h-.12v.769h.12v-.769z"></path>
        <path fill="#A4D2FF" d="M95.936 126.831h-.12v.769h.12v-.769z"></path>
        <path fill="#A5D3FF" d="M96.046 126.831h-.12v.769h.12v-.769z"></path>
        <path fill="#A6D3FF" d="M96.165 126.831h-.12v.769h.12v-.769z"></path>
        <path fill="#A7D4FF" d="M96.285 126.831h-.12v.769h.12v-.769z"></path>
        <path fill="#A9D4FF" d="M96.404 126.831h-.12v.769h.12v-.769z"></path>
        <path fill="#AAD5FF" d="M96.514 126.831h-.12v.769h.12v-.769z"></path>
        <path fill="#ABD5FF" d="M96.634 126.831h-.12v.769h.12v-.769z"></path>
        <path fill="#ACD6FF" d="M96.754 126.831h-.12v.769h.12v-.769z"></path>
        <path fill="#ADD7FF" d="M96.873 126.831h-.12v.769h.12v-.769z"></path>
        <path fill="#AFD7FF" d="M96.993 126.831h-.12v.769h.12v-.769z"></path>
        <path fill="#B0D8FF" d="M97.103 126.831h-.12v.769h.12v-.769z"></path>
        <path fill="#B1D8FF" d="M97.222 126.831h-.12v.769h.12v-.769z"></path>
        <path fill="#B2D9FF" d="M97.342 126.831h-.12v.769h.12v-.769z"></path>
        <path fill="#B4D9FF" d="M97.462 126.831h-.12v.769h.12v-.769z"></path>
        <path fill="#B5DAFF" d="M97.572 126.831h-.12v.769h.12v-.769z"></path>
        <path fill="#B6DBFF" d="M97.692 126.831h-.12v.769h.12v-.769z"></path>
        <path fill="#B7DBFF" d="M97.811 126.831h-.12v.769h.12v-.769z"></path>
        <path fill="#B8DCFF" d="M97.931 126.831h-.12v.769h.12v-.769z"></path>
        <path fill="#BADCFF" d="M98.041 126.831h-.12v.769h.12v-.769z"></path>
        <path fill="#BDF" d="M98.16 126.831h-.12v.769h.12v-.769z"></path>
        <path fill="#BCDDFF" d="M98.28 126.831h-.12v.769h.12v-.769z"></path>
        <path fill="#BDDEFF" d="M98.4 126.831h-.12v.769h.12v-.769z"></path>
        <path fill="#BEDFFF" d="M98.51 126.831h-.12v.769h.12v-.769z"></path>
        <path fill="#C0DFFF" d="M98.63 126.831h-.12v.769h.12v-.769z"></path>
        <path fill="#C1E0FF" d="M98.749 126.831h-.12v.769h.12v-.769z"></path>
        <path fill="#C2E0FF" d="M98.869 126.831h-.12v.769h.12v-.769z"></path>
        <path fill="#C3E1FF" d="M98.979 126.831h-.12v.769h.12v-.769z"></path>
        <path fill="#C5E1FF" d="M99.098 126.831h-.12v.769h.12v-.769z"></path>
        <path fill="#C6E2FF" d="M99.218 126.831h-.12v.769h.12v-.769z"></path>
        <path fill="#C7E3FF" d="M99.338 126.831h-.12v.769h.12v-.769z"></path>
        <path fill="#C8E3FF" d="M99.447 126.831h-.12v.769h.12v-.769z"></path>
        <path fill="#C9E4FF" d="M99.568 126.831h-.12v.769h.12v-.769z"></path>
        <path fill="#CBE4FF" d="M99.688 126.831h-.12v.769h.12v-.769z"></path>
        <path fill="#CDE5FF" d="M99.807 126.831h-.12v.769h.12v-.769z"></path>
        <path fill="#CEE5FF" d="M99.917 126.831h-.12v.769h.12v-.769z"></path>
        <path fill="#CFE6FF" d="M100.036 126.831h-.12v.769h.12v-.769z"></path>
        <path fill="#D0E7FF" d="M100.156 126.831h-.12v.769h.12v-.769z"></path>
        <path fill="#D2E7FF" d="M100.276 126.831h-.119v.769h.119v-.769z"></path>
        <path fill="#D3E8FF" d="M100.385 126.831h-.119v.769h.119v-.769z"></path>
        <path fill="#D4E8FF" d="M100.505 126.831h-.12v.769h.12v-.769z"></path>
        <path
          fill="#D5E9FF"
          d="M100.625 126.831h-.12v.769h.12v-.769zM100.644 126.831h-.019v.769h.019v-.769z"
        ></path>
        <path fill="#99CEFF" d="M88.243 126.831h-.12v.769h.12v-.769z"></path>
        <path fill="#9BCEFF" d="M88.362 126.831h-.12v.769h.12v-.769z"></path>
        <path fill="#9CCFFF" d="M88.472 126.831h-.12v.769h.12v-.769z"></path>
        <path fill="#9DCFFF" d="M88.592 126.831h-.12v.769h.12v-.769z"></path>
        <path fill="#9ED0FF" d="M88.712 126.831h-.12v.769h.12v-.769z"></path>
        <path fill="#9FD1FF" d="M88.831 126.831h-.12v.769h.12v-.769z"></path>
        <path fill="#A1D1FF" d="M88.941 126.831h-.12v.769h.12v-.769z"></path>
        <path fill="#A2D2FF" d="M89.06 126.831h-.12v.769h.12v-.769z"></path>
        <path fill="#A4D2FF" d="M89.18 126.831h-.119v.769h.12v-.769z"></path>
        <path fill="#A5D3FF" d="M89.3 126.831h-.12v.769h.12v-.769z"></path>
        <path fill="#A6D3FF" d="M89.41 126.831h-.12v.769h.12v-.769z"></path>
        <path fill="#A7D4FF" d="M89.53 126.831h-.12v.769h.12v-.769z"></path>
        <path fill="#A9D4FF" d="M89.65 126.831h-.12v.769h.12v-.769z"></path>
        <path fill="#AAD5FF" d="M89.759 126.831h-.12v.769h.12v-.769z"></path>
        <path fill="#ABD5FF" d="M89.879 126.831h-.12v.769h.12v-.769z"></path>
        <path fill="#ACD6FF" d="M89.999 126.831h-.12v.769h.12v-.769z"></path>
        <path fill="#ADD7FF" d="M90.118 126.831h-.12v.769h.12v-.769z"></path>
        <path fill="#AFD7FF" d="M90.228 126.831h-.12v.769h.12v-.769z"></path>
        <path fill="#B0D8FF" d="M90.348 126.831h-.12v.769h.12v-.769z"></path>
        <path fill="#B1D8FF" d="M90.467 126.831h-.12v.769h.12v-.769z"></path>
        <path fill="#B2D9FF" d="M90.587 126.831h-.12v.769h.12v-.769z"></path>
        <path fill="#B4D9FF" d="M90.697 126.831h-.12v.769h.12v-.769z"></path>
        <path fill="#B5DAFF" d="M90.817 126.831h-.12v.769h.12v-.769z"></path>
        <path fill="#B6DBFF" d="M90.937 126.831h-.12v.769h.12v-.769z"></path>
        <path fill="#B7DBFF" d="M91.046 126.831h-.12v.769h.12v-.769z"></path>
        <path fill="#B8DCFF" d="M91.166 126.831h-.12v.769h.12v-.769z"></path>
        <path fill="#BADCFF" d="M91.286 126.831h-.12v.769h.12v-.769z"></path>
        <path fill="#BDF" d="M91.405 126.831h-.12v.769h.12v-.769z"></path>
        <path fill="#BCDDFF" d="M91.515 126.831h-.12v.769h.12v-.769z"></path>
        <path fill="#BDDEFF" d="M91.634 126.831h-.12v.769h.12v-.769z"></path>
        <path fill="#BEDFFF" d="M91.754 126.831h-.12v.769h.12v-.769z"></path>
        <path fill="#C0DFFF" d="M91.875 126.831h-.12v.769h.12v-.769z"></path>
        <path fill="#C1E0FF" d="M91.984 126.831h-.12v.769h.12v-.769z"></path>
        <path fill="#C2E0FF" d="M92.104 126.831h-.12v.769h.12v-.769z"></path>
        <path fill="#C3E1FF" d="M92.224 126.831h-.12v.769h.12v-.769z"></path>
        <path fill="#C5E1FF" d="M92.333 126.831h-.12v.769h.12v-.769z"></path>
        <path fill="#C6E2FF" d="M92.454 126.831h-.12v.769h.12v-.769z"></path>
        <path fill="#C7E3FF" d="M92.573 126.831h-.12v.769h.12v-.769z"></path>
        <path fill="#C8E3FF" d="M92.692 126.831h-.12v.769h.12v-.769z"></path>
        <path fill="#C9E4FF" d="M92.802 126.831h-.12v.769h.12v-.769z"></path>
        <path fill="#CBE4FF" d="M92.922 126.831h-.12v.769h.12v-.769z"></path>
        <path fill="#CDE5FF" d="M93.042 126.831h-.12v.769h.12v-.769z"></path>
        <path fill="#CEE5FF" d="M93.162 126.831h-.12v.769h.12v-.769z"></path>
        <path fill="#CFE6FF" d="M93.271 126.831h-.12v.769h.12v-.769z"></path>
        <path fill="#D0E7FF" d="M93.39 126.831h-.119v.769h.12v-.769z"></path>
        <path fill="#D2E7FF" d="M93.51 126.831h-.119v.769h.12v-.769z"></path>
        <path fill="#D3E8FF" d="M93.62 126.831h-.119v.769h.12v-.769z"></path>
        <path fill="#D4E8FF" d="M93.74 126.831h-.119v.769h.12v-.769z"></path>
        <path
          fill="#D5E9FF"
          d="M93.86 126.831h-.12v.769h.12v-.769zM93.88 126.831h-.02v.769h.02v-.769z"
        ></path>
        <path fill="#99CEFF" d="M81.487 126.831h-.12v.769h.12v-.769z"></path>
        <path fill="#9BCEFF" d="M81.608 126.831h-.12v.769h.12v-.769z"></path>
        <path fill="#9CCFFF" d="M81.727 126.831h-.12v.769h.12v-.769z"></path>
        <path fill="#9DCFFF" d="M81.837 126.831h-.12v.769h.12v-.769z"></path>
        <path fill="#9ED0FF" d="M81.957 126.831h-.12v.769h.12v-.769z"></path>
        <path fill="#9FD1FF" d="M82.076 126.831h-.12v.769h.12v-.769z"></path>
        <path fill="#A1D1FF" d="M82.186 126.831h-.12v.769h.12v-.769z"></path>
        <path fill="#A2D2FF" d="M82.306 126.831h-.12v.769h.12v-.769z"></path>
        <path fill="#A4D2FF" d="M82.426 126.831h-.12v.769h.12v-.769z"></path>
        <path fill="#A5D3FF" d="M82.545 126.831h-.12v.769h.12v-.769z"></path>
        <path fill="#A6D3FF" d="M82.655 126.831h-.12v.769h.12v-.769z"></path>
        <path fill="#A7D4FF" d="M82.775 126.831h-.12v.769h.12v-.769z"></path>
        <path fill="#A9D4FF" d="M82.895 126.831h-.12v.769h.12v-.769z"></path>
        <path fill="#AAD5FF" d="M83.004 126.831h-.12v.769h.12v-.769z"></path>
        <path fill="#ABD5FF" d="M83.124 126.831h-.12v.769h.12v-.769z"></path>
        <path fill="#ACD6FF" d="M83.244 126.831h-.12v.769h.12v-.769z"></path>
        <path fill="#ADD7FF" d="M83.353 126.831h-.12v.769h.12v-.769z"></path>
        <path fill="#AFD7FF" d="M83.473 126.831h-.12v.769h.12v-.769z"></path>
        <path fill="#B0D8FF" d="M83.593 126.831h-.12v.769h.12v-.769z"></path>
        <path fill="#B1D8FF" d="M83.713 126.831h-.12v.769h.12v-.769z"></path>
        <path fill="#B2D9FF" d="M83.823 126.831h-.12v.769h.12v-.769z"></path>
        <path fill="#B4D9FF" d="M83.942 126.831h-.12v.769h.12v-.769z"></path>
        <path fill="#B5DAFF" d="M84.062 126.831h-.12v.769h.12v-.769z"></path>
        <path fill="#B6DBFF" d="M84.172 126.831h-.12v.769h.12v-.769z"></path>
        <path fill="#B7DBFF" d="M84.291 126.831h-.12v.769h.12v-.769z"></path>
        <path fill="#B8DCFF" d="M84.411 126.831h-.12v.769h.12v-.769z"></path>
        <path fill="#BADCFF" d="M84.52 126.831h-.12v.769h.12v-.769z"></path>
        <path fill="#BDF" d="M84.64 126.831h-.12v.769h.12v-.769z"></path>
        <path fill="#BCDDFF" d="M84.76 126.831h-.12v.769h.12v-.769z"></path>
        <path fill="#BDDEFF" d="M84.88 126.831h-.12v.769h.12v-.769z"></path>
        <path fill="#BEDFFF" d="M84.99 126.831h-.12v.769h.12v-.769z"></path>
        <path fill="#C0DFFF" d="M85.11 126.831h-.12v.769h.12v-.769z"></path>
        <path fill="#C1E0FF" d="M85.23 126.831h-.12v.769h.12v-.769z"></path>
        <path fill="#C2E0FF" d="M85.34 126.831h-.12v.769h.12v-.769z"></path>
        <path fill="#C3E1FF" d="M85.46 126.831h-.12v.769h.12v-.769z"></path>
        <path fill="#C5E1FF" d="M85.578 126.831h-.12v.769h.12v-.769z"></path>
        <path fill="#C6E2FF" d="M85.688 126.831h-.12v.769h.12v-.769z"></path>
        <path fill="#C7E3FF" d="M85.808 126.831h-.12v.769h.12v-.769z"></path>
        <path fill="#C8E3FF" d="M85.927 126.831h-.12v.769h.12v-.769z"></path>
        <path fill="#C9E4FF" d="M86.047 126.831h-.12v.769h.12v-.769z"></path>
        <path fill="#CBE4FF" d="M86.157 126.831h-.12v.769h.12v-.769z"></path>
        <path fill="#CDE5FF" d="M86.276 126.831h-.12v.769h.12v-.769z"></path>
        <path fill="#CEE5FF" d="M86.397 126.831h-.12v.769h.12v-.769z"></path>
        <path fill="#CFE6FF" d="M86.506 126.831h-.12v.769h.12v-.769z"></path>
        <path fill="#D0E7FF" d="M86.627 126.831h-.12v.769h.12v-.769z"></path>
        <path fill="#D2E7FF" d="M86.746 126.831h-.12v.769h.12v-.769z"></path>
        <path fill="#D3E8FF" d="M86.856 126.831h-.12v.769h.12v-.769z"></path>
        <path fill="#D4E8FF" d="M86.976 126.831h-.12v.769h.12v-.769z"></path>
        <path fill="#D5E9FF" d="M87.096 126.831h-.12v.769h.12v-.769z"></path>
        <path fill="#D5E9FF" d="M87.115 126.831h-.02v.769h.02v-.769z"></path>
        <path fill="#99CEFF" d="M75.821 126.831h-.07v.769h.07v-.769z"></path>
        <path fill="#9BCEFF" d="M75.891 126.831h-.07v.769h.07v-.769z"></path>
        <path fill="#9CCFFF" d="M75.961 126.831h-.07v.769h.07v-.769z"></path>
        <path fill="#9DCFFF" d="M76.03 126.831h-.07v.769h.07v-.769z"></path>
        <path fill="#9ED0FF" d="M76.1 126.831h-.07v.769h.07v-.769z"></path>
        <path fill="#9FD1FF" d="M76.17 126.831h-.07v.769h.07v-.769z"></path>
        <path fill="#A1D1FF" d="M76.23 126.831h-.07v.769h.07v-.769z"></path>
        <path fill="#A2D2FF" d="M76.3 126.831h-.07v.769h.07v-.769z"></path>
        <path fill="#A4D2FF" d="M76.37 126.831h-.07v.769h.07v-.769z"></path>
        <path fill="#A5D3FF" d="M76.44 126.831h-.07v.769h.07v-.769z"></path>
        <path fill="#A6D3FF" d="M76.51 126.831h-.07v.769h.07v-.769z"></path>
        <path fill="#A7D4FF" d="M76.58 126.831h-.07v.769h.07v-.769z"></path>
        <path fill="#A9D4FF" d="M76.65 126.831h-.07v.769h.07v-.769z"></path>
        <path fill="#AAD5FF" d="M76.72 126.831h-.07v.769h.07v-.769z"></path>
        <path fill="#ABD5FF" d="M76.79 126.831h-.07v.769h.07v-.769z"></path>
        <path fill="#ACD6FF" d="M76.859 126.831h-.07v.769h.07v-.769z"></path>
        <path fill="#ADD7FF" d="M76.919 126.831h-.07v.769h.07v-.769z"></path>
        <path fill="#AFD7FF" d="M76.989 126.831h-.07v.769h.07v-.769z"></path>
        <path fill="#B0D8FF" d="M77.058 126.831h-.07v.769h.07v-.769z"></path>
        <path fill="#B1D8FF" d="M77.128 126.831h-.07v.769h.07v-.769z"></path>
        <path fill="#B2D9FF" d="M77.198 126.831h-.07v.769h.07v-.769z"></path>
        <path fill="#B4D9FF" d="M77.268 126.831h-.07v.769h.07v-.769z"></path>
        <path fill="#B5DAFF" d="M77.338 126.831h-.07v.769h.07v-.769z"></path>
        <path fill="#B6DBFF" d="M77.408 126.831h-.07v.769h.07v-.769z"></path>
        <path fill="#B7DBFF" d="M77.478 126.831h-.07v.769h.07v-.769z"></path>
        <path fill="#B8DCFF" d="M77.547 126.831h-.07v.769h.07v-.769z"></path>
        <path fill="#BADCFF" d="M77.607 126.831h-.07v.769h.07v-.769z"></path>
        <path fill="#BDF" d="M77.677 126.831h-.07v.769h.07v-.769z"></path>
        <path fill="#BCDDFF" d="M77.747 126.831h-.07v.769h.07v-.769z"></path>
        <path fill="#BDDEFF" d="M77.817 126.831h-.07v.769h.07v-.769z"></path>
        <path fill="#BEDFFF" d="M77.887 126.831h-.07v.769h.07v-.769z"></path>
        <path fill="#C0DFFF" d="M77.957 126.831h-.07v.769h.07v-.769z"></path>
        <path fill="#C1E0FF" d="M78.026 126.831h-.07v.769h.07v-.769z"></path>
        <path fill="#C2E0FF" d="M78.096 126.831h-.07v.769h.07v-.769z"></path>
        <path fill="#C3E1FF" d="M78.166 126.831h-.07v.769h.07v-.769z"></path>
        <path fill="#C5E1FF" d="M78.236 126.831h-.07v.769h.07v-.769z"></path>
        <path fill="#C6E2FF" d="M78.295 126.831h-.07v.769h.07v-.769z"></path>
        <path fill="#C7E3FF" d="M78.366 126.831h-.07v.769h.07v-.769z"></path>
        <path fill="#C8E3FF" d="M78.436 126.831h-.07v.769h.07v-.769z"></path>
        <path fill="#C9E4FF" d="M78.506 126.831h-.07v.769h.07v-.769z"></path>
        <path fill="#CBE4FF" d="M78.576 126.831h-.07v.769h.07v-.769z"></path>
        <path fill="#CDE5FF" d="M78.645 126.831h-.07v.769h.07v-.769z"></path>
        <path fill="#CEE5FF" d="M78.715 126.831h-.07v.769h.07v-.769z"></path>
        <path fill="#CFE6FF" d="M78.785 126.831h-.07v.769h.07v-.769z"></path>
        <path fill="#D0E7FF" d="M78.855 126.831h-.07v.769h.07v-.769z"></path>
        <path fill="#D2E7FF" d="M78.925 126.831h-.07v.769h.07v-.769z"></path>
        <path fill="#D3E8FF" d="M78.984 126.831h-.07v.769h.07v-.769z"></path>
        <path fill="#D4E8FF" d="M79.054 126.831h-.07v.769h.07v-.769z"></path>
        <path
          fill="#D5E9FF"
          d="M79.124 126.831h-.07v.769h.07v-.769zM79.144 126.831h-.02v.769h.02v-.769z"
        ></path>
        <path fill="#99CEFF" d="M71.839 126.831h-.07v.769h.07v-.769z"></path>
        <path fill="#9BCEFF" d="M71.908 126.831h-.07v.769h.07v-.769z"></path>
        <path fill="#9CCFFF" d="M71.978 126.831h-.07v.769h.07v-.769z"></path>
        <path fill="#9DCFFF" d="M72.048 126.831h-.07v.769h.07v-.769z"></path>
        <path fill="#9ED0FF" d="M72.118 126.831h-.07v.769h.07v-.769z"></path>
        <path fill="#9FD1FF" d="M72.178 126.831h-.07v.769h.07v-.769z"></path>
        <path fill="#A1D1FF" d="M72.247 126.831h-.07v.769h.07v-.769z"></path>
        <path fill="#A2D2FF" d="M72.318 126.831h-.07v.769h.07v-.769z"></path>
        <path fill="#A4D2FF" d="M72.388 126.831h-.07v.769h.07v-.769z"></path>
        <path fill="#A5D3FF" d="M72.457 126.831h-.07v.769h.07v-.769z"></path>
        <path fill="#A6D3FF" d="M72.527 126.831h-.07v.769h.07v-.769z"></path>
        <path fill="#A7D4FF" d="M72.597 126.831h-.07v.769h.07v-.769z"></path>
        <path fill="#A9D4FF" d="M72.667 126.831h-.07v.769h.07v-.769z"></path>
        <path fill="#AAD5FF" d="M72.737 126.831h-.07v.769h.07v-.769z"></path>
        <path fill="#ABD5FF" d="M72.796 126.831h-.07v.769h.07v-.769z"></path>
        <path fill="#ACD6FF" d="M72.866 126.831h-.07v.769h.07v-.769z"></path>
        <path fill="#ADD7FF" d="M72.936 126.831h-.07v.769h.07v-.769z"></path>
        <path fill="#AFD7FF" d="M73.006 126.831h-.07v.769h.07v-.769z"></path>
        <path fill="#B0D8FF" d="M73.076 126.831h-.07v.769h.07v-.769z"></path>
        <path fill="#B1D8FF" d="M73.145 126.831h-.07v.769h.07v-.769z"></path>
        <path fill="#B2D9FF" d="M73.216 126.831h-.07v.769h.07v-.769z"></path>
        <path fill="#B4D9FF" d="M73.285 126.831h-.07v.769h.07v-.769z"></path>
        <path fill="#B5DAFF" d="M73.355 126.831h-.07v.769h.07v-.769z"></path>
        <path fill="#B6DBFF" d="M73.415 126.831h-.07v.769h.07v-.769z"></path>
        <path fill="#B7DBFF" d="M73.485 126.831h-.07v.769h.07v-.769z"></path>
        <path fill="#B8DCFF" d="M73.555 126.831h-.07v.769h.07v-.769z"></path>
        <path fill="#BADCFF" d="M73.625 126.831h-.07v.769h.07v-.769z"></path>
        <path fill="#BDF" d="M73.694 126.831h-.07v.769h.07v-.769z"></path>
        <path fill="#BCDDFF" d="M73.765 126.831h-.07v.769h.07v-.769z"></path>
        <path fill="#BDDEFF" d="M73.834 126.831h-.07v.769h.07v-.769z"></path>
        <path fill="#BEDFFF" d="M73.904 126.831h-.07v.769h.07v-.769z"></path>
        <path fill="#C0DFFF" d="M73.974 126.831h-.07v.769h.07v-.769z"></path>
        <path fill="#C1E0FF" d="M74.033 126.831h-.07v.769h.07v-.769z"></path>
        <path fill="#C2E0FF" d="M74.103 126.831h-.07v.769h.07v-.769z"></path>
        <path fill="#C3E1FF" d="M74.174 126.831h-.07v.769h.07v-.769z"></path>
        <path fill="#C5E1FF" d="M74.243 126.831h-.07v.769h.07v-.769z"></path>
        <path fill="#C6E2FF" d="M74.313 126.831h-.07v.769h.07v-.769z"></path>
        <path fill="#C7E3FF" d="M74.383 126.831h-.07v.769h.07v-.769z"></path>
        <path fill="#C8E3FF" d="M74.453 126.831h-.07v.769h.07v-.769z"></path>
        <path fill="#C9E4FF" d="M74.523 126.831h-.07v.769h.07v-.769z"></path>
        <path fill="#CBE4FF" d="M74.582 126.831h-.07v.769h.07v-.769z"></path>
        <path fill="#CDE5FF" d="M74.652 126.831h-.07v.769h.07v-.769z"></path>
        <path fill="#CEE5FF" d="M74.722 126.831h-.07v.769h.07v-.769z"></path>
        <path fill="#CFE6FF" d="M74.792 126.831h-.07v.769h.07v-.769z"></path>
        <path fill="#D0E7FF" d="M74.862 126.831h-.07v.769h.07v-.769z"></path>
        <path fill="#D2E7FF" d="M74.932 126.831h-.07v.769h.07v-.769z"></path>
        <path fill="#D3E8FF" d="M75.001 126.831h-.07v.769h.07v-.769z"></path>
        <path fill="#D4E8FF" d="M75.072 126.831h-.07v.769h.07v-.769z"></path>
        <path fill="#D5E9FF" d="M75.141 126.831h-.07v.769h.07v-.769z"></path>
        <path fill="#D5E9FF" d="M75.14 126.831h-.01v.769h.01v-.769z"></path>
        <path fill="#99CEFF" d="M68.097 126.831h-.07v.769h.07v-.769z"></path>
        <path fill="#9BCEFF" d="M68.157 126.831h-.07v.769h.07v-.769z"></path>
        <path fill="#9CCFFF" d="M68.227 126.831h-.07v.769h.07v-.769z"></path>
        <path fill="#9DCFFF" d="M68.296 126.831h-.07v.769h.07v-.769z"></path>
        <path fill="#9ED0FF" d="M68.366 126.831h-.07v.769h.07v-.769z"></path>
        <path fill="#9FD1FF" d="M68.436 126.831h-.07v.769h.07v-.769z"></path>
        <path fill="#A1D1FF" d="M68.506 126.831h-.07v.769h.07v-.769z"></path>
        <path fill="#A2D2FF" d="M68.576 126.831h-.07v.769h.07v-.769z"></path>
        <path fill="#A4D2FF" d="M68.636 126.831h-.07v.769h.07v-.769z"></path>
        <path fill="#A5D3FF" d="M68.706 126.831h-.07v.769h.07v-.769z"></path>
        <path fill="#A6D3FF" d="M68.775 126.831h-.07v.769h.07v-.769z"></path>
        <path fill="#A7D4FF" d="M68.846 126.831h-.07v.769h.07v-.769z"></path>
        <path fill="#A9D4FF" d="M68.915 126.831h-.07v.769h.07v-.769z"></path>
        <path fill="#AAD5FF" d="M68.985 126.831h-.07v.769h.07v-.769z"></path>
        <path fill="#ABD5FF" d="M69.055 126.831h-.07v.769h.07v-.769z"></path>
        <path fill="#ACD6FF" d="M69.124 126.831h-.07v.769h.07v-.769z"></path>
        <path fill="#ADD7FF" d="M69.185 126.831h-.07v.769h.07v-.769z"></path>
        <path fill="#AFD7FF" d="M69.254 126.831h-.07v.769h.07v-.769z"></path>
        <path fill="#B0D8FF" d="M69.325 126.831h-.07v.769h.07v-.769z"></path>
        <path fill="#B1D8FF" d="M69.394 126.831h-.07v.769h.07v-.769z"></path>
        <path fill="#B2D9FF" d="M69.463 126.831h-.07v.769h.07v-.769z"></path>
        <path fill="#B4D9FF" d="M69.534 126.831h-.07v.769h.07v-.769z"></path>
        <path fill="#B5DAFF" d="M69.603 126.831h-.07v.769h.07v-.769z"></path>
        <path fill="#B6DBFF" d="M69.674 126.831h-.07v.769h.07v-.769z"></path>
        <path fill="#B7DBFF" d="M69.733 126.831h-.07v.769h.07v-.769z"></path>
        <path fill="#B8DCFF" d="M69.803 126.831h-.07v.769h.07v-.769z"></path>
        <path fill="#BADCFF" d="M69.873 126.831h-.07v.769h.07v-.769z"></path>
        <path fill="#BDF" d="M69.943 126.831h-.07v.769h.07v-.769z"></path>
        <path fill="#BCDDFF" d="M70.013 126.831h-.07v.769h.07v-.769z"></path>
        <path fill="#BDDEFF" d="M70.082 126.831h-.07v.769h.07v-.769z"></path>
        <path fill="#BEDFFF" d="M70.152 126.831h-.07v.769h.07v-.769z"></path>
        <path fill="#C0DFFF" d="M70.212 126.831h-.07v.769h.07v-.769z"></path>
        <path fill="#C1E0FF" d="M70.283 126.831h-.07v.769h.07v-.769z"></path>
        <path fill="#C2E0FF" d="M70.352 126.831h-.07v.769h.07v-.769z"></path>
        <path fill="#C3E1FF" d="M70.422 126.831h-.07v.769h.07v-.769z"></path>
        <path fill="#C5E1FF" d="M70.492 126.831h-.07v.769h.07v-.769z"></path>
        <path fill="#C6E2FF" d="M70.561 126.831h-.07v.769h.07v-.769z"></path>
        <path fill="#C7E3FF" d="M70.632 126.831h-.07v.769h.07v-.769z"></path>
        <path fill="#C8E3FF" d="M70.701 126.831h-.07v.769h.07v-.769z"></path>
        <path fill="#C9E4FF" d="M70.76 126.831h-.07v.769h.07v-.769z"></path>
        <path fill="#CBE4FF" d="M70.831 126.831h-.07v.769h.07v-.769z"></path>
        <path fill="#CDE5FF" d="M70.9 126.831h-.07v.769h.07v-.769z"></path>
        <path fill="#CEE5FF" d="M70.97 126.831h-.07v.769h.07v-.769z"></path>
        <path fill="#CFE6FF" d="M71.04 126.831h-.07v.769h.07v-.769z"></path>
        <path fill="#D0E7FF" d="M71.11 126.831h-.07v.769h.07v-.769z"></path>
        <path fill="#D2E7FF" d="M71.18 126.831h-.07v.769h.07v-.769z"></path>
        <path fill="#D3E8FF" d="M71.25 126.831h-.07v.769h.07v-.769z"></path>
        <path fill="#D4E8FF" d="M71.31 126.831h-.07v.769h.07v-.769z"></path>
        <path
          fill="#D5E9FF"
          d="M71.38 126.831h-.07v.769h.07v-.769zM71.39 126.831h-.01v.769h.01v-.769z"
        ></path>
        <path
          fill="#101C3A"
          d="M125.23 81.827H50.177c-.967 0-1.746.908-1.566 1.847l8.092 43.566h63.359l6.755-43.836c.03-.918-.629-1.577-1.587-1.577z"
        ></path>
        <path
          fill="#101C3A"
          d="M56.932 129.236c-.02.15.12.28.3.28h61.672c.359 0 .728-.25.828-.559l.339-1.727H56.683l.25 2.006zM81.666 31.603a1.248 1.248 0 102.496 0 1.248 1.248 0 00-2.496 0zM90.327 31.603a1.248 1.248 0 102.495 0 1.248 1.248 0 00-2.495 0z"
        ></path>
      </g>
    </svg>
  );
}

export default LoginToDownloadModalSvg;